"use strict";

define('model/document.decision',['require','exports','module','./base','../config','datakit/util/url','underscore'],function (require, exports, module) {
  var Model = require('./base'),
    config = require('../config'),
    url = require('datakit/util/url'),
    _ = require('underscore');
  var DocumentDecision = Model.extend({
    urlRoot: '/rs/api/decision',
    virtual: {
      'decisionType.description': Model.createKeyPathVirtual('decisionType.description'),
      'status': Model.createKeyPathVirtual('decisionType.description'),
      'studyTitle': Model.createKeyPathVirtual('document.studyTitle'),
      'studyLabel': Model.createKeyPathVirtual('document.studyLabel'),
      'templateType': Model.createKeyPathVirtual('document.templateType'),
      'responsiblePersonId': Model.createKeyPathVirtual('responsiblePerson.id'),
      'documentId': Model.createKeyPathVirtual('document.id'),
      'policyName': Model.createKeyPathVirtual('document.commonRulePolicy'),
      'pending': function pending() {
        return !this.get('finalizedDate');
      }
    },
    childModels: {
      document: 'Document',
      categories: 'DocumentDecisionCategory',
      children: 'DocumentDecision',
      decisionType: 'DocumentDecisionType',
      responsiblePerson: 'Person',
      motioned: 'Person',
      seconded: 'Person'
    },
    validation: function validation() {
      var validators = Backbone.Validation.validators;
      return {
        resultDate: {
          required: this.isResultDateRequired()
        },
        expirationDate: function expirationDate(value, attr, model) {
          if (!this.isExpirationDateVisible()) {
            return '';
          }
          var required = validators.required(value, attr, this.isExpirationDateRequired(), model);
          if (required) {
            return required;
          } else if (value && value <= this.get('resultDate')) {
            return 'Expiration date must exceed the result date.';
          }
        },
        adminCheckinDate: {
          required: false
        },
        expirationJustification: {
          minLength: 1,
          required: this.useExpirationOrAdminCheckinDate() && this.isExpirationDateRequired(),
          msg: 'Justification for mandating continuing review is required.'
        },
        voteFor: {
          pattern: 'digits',
          required: false
        },
        voteAgainst: {
          pattern: 'digits',
          required: false
        },
        voteAbstain: {
          pattern: 'digits',
          required: false
        }
      };
    },
    promote: function promote() {
      return this.request({
        url: url.template('/rs/api/decision/promote/:id', this),
        type: 'POST'
      });
    },
    useExpirationOrAdminCheckinDate: function useExpirationOrAdminCheckinDate() {
      return this.isExpeditedPost2018() || this.isLimitedIrb() || this.isExempt() || this.isAdminPost2018();
    },
    submissionSupportsAdminCheckinDate: function submissionSupportsAdminCheckinDate() {
      var templateType = this.get('document').get('templateType');
      return this.useExpirationOrAdminCheckinDate() && (templateType === 'Initial' || templateType === 'Renewal' || templateType === 'Modification');
    },
    decisionSupportsAdminCheckinDate: function decisionSupportsAdminCheckinDate(decisionType) {
      if (!this.submissionSupportsAdminCheckinDate()) {
        return false;
      }
      if (!decisionType) {
        decisionType = this.get("decisionType");
      }
      if (this.isExempt()) {
        var decisionTypeDescription = decisionType ? decisionType.get('description') : null;
        if (this.get('policyName') === config.PRE_2018_POLICY) {
          return _.contains(config.ADMIN_CHECK_IN_PRE_2018_DECISION_DESCRIPTIONS, decisionTypeDescription);
        }
        return _.contains(config.ADMIN_CHECK_IN_DECISION_DESCRIPTIONS, decisionTypeDescription);
      } else {
        var decisionTypeRoute = decisionType ? decisionType.get('route') : null;
        return decisionTypeRoute === 'Approved';
      }
    },
    submissionSupportsExpirationDate: function submissionSupportsExpirationDate() {
      if (this.isLimitedIrb()) return false;
      if (this.isExempt()) return false;
      var templateType = this.get('document').get('templateType');
      return templateType === 'Initial' || templateType === 'Renewal' || templateType === 'Modification';
    },
    decisionSupportsExpirationDate: function decisionSupportsExpirationDate(decisionType) {
      var decisionTypeDescription = !!decisionType ? decisionType.get('description') : this.get('decisionType.description');
      return this.submissionSupportsExpirationDate() && _.contains(config.EXPIRABLE_DECISION_DESCRIPTIONS, decisionTypeDescription);
    },
    isExpirationDateVisible: function isExpirationDateVisible(decisionType) {
      if (this.useExpirationOrAdminCheckinDate()) {
        return this.decisionSupportsExpirationDate(decisionType) && this.attributes.continuingReviewRequired;
      } else {
        return this.decisionSupportsExpirationDate(decisionType);
      }
    },
    isResultDateRequired: function isResultDateRequired(decisionType) {
      return !!decisionType ? decisionType.get('description') === 'Approved' : this.get('decisionType.description') === 'Approved';
    },
    isExpirationDateRequired: function isExpirationDateRequired() {
      return this.get('continuingReviewRequired') && this.decisionSupportsExpirationDate() && this.isResultDateRequired();
    },
    isExpeditedPost2018: function isExpeditedPost2018() {
      return this.get('type') === config.EXPEDITED_REVIEW_TYPE && this.get('policyName') === config.POST_2018_POLICY;
    },
    isAdminPost2018: function isAdminPost2018() {
      return this.get('type') === config.ADMIN_REVIEW_TYPE && this.get('policyName') === config.POST_2018_POLICY;
    },
    isLimitedIrb: function isLimitedIrb() {
      return this.get('type') === config.LIMITED_REVIEW_TYPE;
    },
    isExempt: function isExempt() {
      return this.get('type') === config.EXEMPT_REVIEW_TYPE;
    },
    isAdminCheckInDateUpdated: function isAdminCheckInDateUpdated(studyAdminCheckInDate) {
      if (!this.useExpirationOrAdminCheckinDate()) {
        return false;
      }
      if (!this.decisionSupportsAdminCheckinDate()) {
        return false;
      }
      return this.get("adminCheckinDate") !== studyAdminCheckInDate;
    },
    isExpirationDateUpdated: function isExpirationDateUpdated(studyExpirationDate) {
      if (!this.isExpirationDateVisible()) {
        return false;
      }
      return this.get("expirationDate") !== studyExpirationDate;
    },
    isDecisionOutdated: function isDecisionOutdated() {
      return this.request({
        url: url.template('/rs/api/decision/:id/is-outdated', this),
        type: 'GET'
      });
    }
  }, {
    allByDocumentId: function allByDocumentId(docId) {
      return this.createCollection('/rs/api/decision/document/:documentId').params({
        documentId: docId
      });
    },
    openByDocumentId: function openByDocumentId(docId) {
      return this.createCollection('/rs/api/decision/open/:documentId').params({
        documentId: docId
      });
    }
  });
  module.exports = DocumentDecision;
});

